/* ═══════════════════════════════════════════════════════════════
   GRANIT GALLERY — Page contact premium (JS)
   Architecture en délégation d'événements : résiste aux
   rechargements de sections de l'éditeur Shopify.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.__ggContactInit) return;
  window.__ggContactInit = true;

  var REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var doc = document;

  /* ═══════════ RÉVÉLATION AU SCROLL (avec filet de sécurité) ═══════════ */
  var revealIO = null;
  function bindReveals() {
    var els = doc.querySelectorAll('[data-reveal]:not(.in)');
    if (!els.length) return;
    if (REDUCED || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); revealIO.unobserve(e.target); }
        });
      }, { threshold: 0.15 });
    }
    els.forEach(function (el) { revealIO.observe(el); });
    /* filet : rien ne reste invisible plus de 2,5 s */
    setTimeout(function () {
      doc.querySelectorAll('[data-reveal]:not(.in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < innerHeight && r.bottom > 0) el.classList.add('in');
      });
    }, 2500);
  }

  /* ═══════════ STATUT D'OUVERTURE EN DIRECT ═══════════ */
  function updateStatus() {
    var els = doc.querySelectorAll('[data-gg-status]');
    if (!els.length) return;
    var parseTime = function (s) {
      var m = String(s || '').trim().match(/^(\d{1,2})[h:.](\d{2})$/) || String(s || '').trim().match(/^(\d{1,2})$/);
      return m ? parseInt(m[1], 10) * 60 + (m[2] ? parseInt(m[2], 10) : 0) : null;
    };
    var fmt = function (mins) {
      var mm = mins % 60;
      return Math.floor(mins / 60) + 'h' + (mm < 10 ? '0' + mm : mm);
    };
    els.forEach(function (el) {
      var days = (el.dataset.days || '1,2,3,4,5').split(',').map(Number);
      var oAm = parseTime(el.dataset.openAm), cAm = parseTime(el.dataset.closeAm);
      var oPm = parseTime(el.dataset.openPm), cPm = parseTime(el.dataset.closePm);
      if (oAm === null || cPm === null) return;
      var now = new Date();
      var mins = now.getHours() * 60 + now.getMinutes();
      var workday = days.indexOf(now.getDay()) !== -1;
      var noBreak = cAm === null || oPm === null;
      var inAm = cAm !== null && mins >= oAm && mins < cAm;
      var inPm = oPm !== null && mins >= oPm && mins < cPm;
      var open = workday && (noBreak ? (mins >= oAm && mins < cPm) : (inAm || inPm));
      var state, label;
      if (open) {
        var close = noBreak ? cPm : (inAm ? cAm : cPm);
        if (close - mins <= 45) { state = 'soon'; label = 'Ferme bientôt · à ' + fmt(close); }
        else { state = 'open'; label = 'Disponible · jusqu\'à ' + fmt(close); }
      } else {
        state = 'closed';
        var reopen;
        if (workday && mins < oAm) reopen = 'réouvre à ' + fmt(oAm);
        else if (workday && !noBreak && mins >= cAm && mins < oPm) reopen = 'réouvre à ' + fmt(oPm);
        else {
          var next = (now.getDay() + 1) % 7, hops = 1;
          while (days.indexOf(next) === -1 && hops < 8) { next = (next + 1) % 7; hops++; }
          var noms = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
          reopen = 'réouvre ' + (hops === 1 ? 'demain' : noms[next]) + ' à ' + fmt(oAm);
        }
        label = 'Fermé · ' + reopen;
      }
      el.dataset.state = state;
      var txt = el.querySelector('[data-gg-status-text]');
      if (txt) txt.textContent = label;
    });
  }
  setInterval(updateStatus, 30000);

  /* ═══════════ TITRE MOT À MOT ═══════════ */
  function splitTitle() {
    var title = doc.querySelector('.ghero__title');
    if (!title || title.dataset.split) return;
    title.dataset.split = '1';
    if (!REDUCED) {
      (function wrap(node) {
        [].slice.call(node.childNodes).forEach(function (child) {
          if (child.nodeType === 3) {
            var frag = doc.createDocumentFragment();
            child.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(doc.createTextNode(' ')); return; }
              var w = doc.createElement('span'); w.className = 'gw';
              var inner = doc.createElement('span'); inner.textContent = part;
              w.appendChild(inner); frag.appendChild(w);
            });
            node.replaceChild(frag, child);
          } else if (child.nodeType === 1 && child.tagName !== 'BR') {
            var w2 = doc.createElement('span'); w2.className = 'gw';
            var inner2 = doc.createElement('span');
            node.replaceChild(w2, child);
            inner2.appendChild(child); w2.appendChild(inner2);
          }
        });
      })(title);
      title.querySelectorAll('.gw > span').forEach(function (s, i) {
        s.style.setProperty('--wd', (0.05 + i * 0.07).toFixed(2) + 's');
      });
    }
    requestAnimationFrame(function () { doc.documentElement.classList.add('type-go'); });
    setTimeout(function () { doc.documentElement.classList.add('type-go'); }, 400);
  }

  /* ═══════════ BANNIÈRE : jusqu'à 170px sous le hero ═══════════ */
  function sizeBanner() {
    var banner = doc.querySelector('.page-banner');
    var hero = doc.querySelector('.ghero');
    if (!banner || !hero) return;
    var bottom = hero.getBoundingClientRect().bottom + (window.scrollY || 0);
    banner.style.setProperty('--banner-h', Math.round(bottom + 170) + 'px');
  }

  /* ═══════════ GUIDE DES MATIÈRES ═══════════ */
  function showGuideTab(tab) {
    var name = doc.querySelector('[data-guide-name]');
    if (!name) return;
    var stoneBox = doc.querySelector('[data-guide-stone]');
    var stoneEl = tab.querySelector('.swatch__stone');
    var stoneClass = stoneEl ? [].slice.call(stoneEl.classList).filter(function (c) { return c.indexOf('stone--') === 0; })[0] : '';
    if (stoneBox) stoneBox.className = 'swatch__stone ' + (stoneClass || '');
    name.textContent = tab.dataset.name || tab.textContent.trim();
    var desc = doc.querySelector('[data-guide-desc]'); if (desc) desc.textContent = tab.dataset.desc || '';
    var ideal = doc.querySelector('[data-guide-ideal]'); if (ideal) ideal.textContent = tab.dataset.ideal || '';
    var conseil = doc.querySelector('[data-guide-conseil]'); if (conseil) conseil.textContent = tab.dataset.conseil || '';
    ['chaleur', 'rayures', 'taches', 'entretien'].forEach(function (k) {
      var fill = doc.querySelector('.rating__fill[data-k="' + k + '"]');
      var score = doc.querySelector('.rating__score[data-s="' + k + '"]');
      var attr = 'n' + k.charAt(0).toUpperCase() + k.slice(1);
      var note = Math.max(0, Math.min(5, parseInt(tab.dataset[attr], 10) || 0));
      if (!fill) return;
      fill.style.transition = 'none'; fill.style.width = '0%';
      void fill.offsetWidth; fill.style.transition = '';
      setTimeout(function () { fill.style.width = (note * 20) + '%'; }, 30);
      if (score) score.textContent = note + '/5';
    });
  }
  function initGuide() {
    var tabs = doc.querySelectorAll('.gtab');
    if (!tabs.length || doc.querySelector('.gtab.on')) { if (tabs.length && !doc.querySelector('[data-guide-name]').textContent) showGuideTab(tabs[0]); return; }
    tabs[0].classList.add('on');
    tabs[0].setAttribute('aria-selected', 'true');
    showGuideTab(tabs[0]);
  }

  /* ═══════════ PROGRESSION DU FORMULAIRE ═══════════ */
  var METER_MSG = [
    'Dites-nous tout — 2 minutes suffisent',
    'Bien parti 👌', 'Bien parti 👌',
    'On y est presque…', 'On y est presque…',
    'Encore un détail ou deux',
    'Il ne manque plus rien… ou presque',
    'Parfait — vous pouvez envoyer 🎉'
  ];
  function updateMeter() {
    var bar = doc.querySelector('[data-progress]');
    if (!bar) return;
    var card = doc.querySelector('.form-card');
    var devis = !card || card.dataset.mode !== 'rens';
    var fields = ['ContactForm-firstname', 'ContactForm-name', 'ContactForm-email', 'ContactForm-phone', 'ContactForm-body']
      .map(function (id) { return doc.getElementById(id); }).filter(Boolean);
    var done = fields.filter(function (f) { return f.value.trim() !== '' && f.checkValidity(); }).length;
    var extras = [doc.querySelector('[data-urls-field]')];
    if (devis) {
      extras.push(doc.querySelector('[data-proj-field]'));
      extras.push(doc.querySelector('[data-stone-field]'));
    }
    extras = extras.filter(Boolean);
    extras.forEach(function (x) { if (x.value.trim() !== '') done += 1; });
    var total = fields.length + extras.length;
    var pct = total ? Math.round((done / total) * 100) : 0;
    bar.style.setProperty('--prog', pct + '%');
    var hint = doc.querySelector('[data-progress-hint]'); if (hint) hint.textContent = pct + '%';
    doc.querySelectorAll('[data-meter-segs] .meter__seg').forEach(function (s, i) {
      s.style.display = i < total ? '' : 'none';
      s.classList.toggle('on', i < done);
    });
    var label = doc.querySelector('[data-meter-label]');
    if (label && total) {
      var idx = done === 0 ? 0 : Math.max(1, Math.min(Math.round(done / total * (METER_MSG.length - 1)), METER_MSG.length - 1));
      label.textContent = METER_MSG[idx];
      label.classList.toggle('hot', done / total >= 0.4);
    }
  }

  /* ═══════════ TÉLÉPHONE FR ═══════════ */
  function formatFr(value) {
    var plus = value.trim().indexOf('+') === 0;
    var digits = value.replace(/\D/g, '');
    if (plus) {
      digits = digits.replace(/^33/, '').slice(0, 9);
      return digits.length ? '+33 ' + digits.replace(/(\d)(?=(\d{2})+$)/g, '$1 ').trim() : '+33 ';
    }
    digits = digits.slice(0, 10);
    return digits.replace(/(\d{2})(?=\d)/g, '$1 ').trim();
  }

  /* ═══════════ PALETTE CTRL+K ═══════════ */
  function paletteData() {
    var el = doc.getElementById('GGPaletteData');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }
  var normQ = function (s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); };
  function renderPalette(filter) {
    var list = doc.querySelector('[data-palette-list]');
    if (!list) return;
    var f = normQ(filter);
    var QA = paletteData();
    var hits = QA.filter(function (x) { return !f || normQ(x.q).indexOf(f) !== -1 || normQ(x.k).indexOf(f) !== -1; });
    list.innerHTML = '';
    if (!hits.length) {
      list.innerHTML = '<div class="palette__empty">Pas de réponse toute prête — <a href="#ContactZone" data-palette-close>posez-la via le formulaire</a>, réponse sous 24h.</div>';
      return;
    }
    hits.forEach(function (x, i) {
      var g = doc.createElement('div');
      g.className = 'palette__group' + (f && i === 0 ? ' open' : '');
      var btn = doc.createElement('button');
      btn.type = 'button';
      btn.className = 'palette__item';
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/></svg>';
      btn.appendChild(doc.createTextNode(x.q));
      var ans = doc.createElement('div');
      ans.className = 'palette__answer';
      ans.innerHTML = x.a;
      g.appendChild(btn); g.appendChild(ans);
      list.appendChild(g);
    });
  }
  function openPalette() {
    var palette = doc.getElementById('AskPalette');
    if (!palette) return;
    palette.classList.add('on');
    renderPalette('');
    var input = palette.querySelector('[data-palette-input]');
    if (input) { input.value = ''; setTimeout(function () { input.focus(); }, 60); }
  }
  function closePalette() {
    var palette = doc.getElementById('AskPalette');
    if (palette) palette.classList.remove('on');
  }

  /* ═══════════ APERÇU MATIÈRE AU SURVOL ═══════════ */
  var pop = null, popTimer = null;
  function ensurePop() {
    if (pop && doc.body.contains(pop)) return pop;
    pop = doc.createElement('div');
    pop.className = 'stonepop';
    pop.setAttribute('aria-hidden', 'true');
    pop.innerHTML = '<div class="stonepop__media"><div class="stonepop__tex"></div><video class="stonepop__video" muted loop playsinline preload="none"></video><span class="stonepop__live"><i></i> Aperçu</span></div><div class="stonepop__cap"><span class="stonepop__name"></span><span class="stonepop__sub"></span></div><span class="stonepop__arrow"></span>';
    doc.body.appendChild(pop);
    pop.querySelector('.stonepop__video').addEventListener('error', function () { pop.classList.remove('has-video'); });
    return pop;
  }
  function showPop(el) {
    if (!el.closest('[data-stonepop]')) return;
    var stoneEl = el.querySelector('.swatch__stone');
    if (!stoneEl) return;
    var p = ensurePop();
    var stoneClass = [].slice.call(stoneEl.classList).filter(function (c) { return c.indexOf('stone--') === 0; })[0];
    var tex = p.querySelector('.stonepop__tex');
    tex.className = 'stonepop__tex ' + (stoneClass ? 'swatch__stone ' + stoneClass : '');
    tex.style.borderRadius = '0';
    p.querySelector('.stonepop__name').textContent = el.dataset.stone || el.dataset.name || el.textContent.trim();
    p.querySelector('.stonepop__sub').textContent = el.dataset.sub || 'texture indicative';
    var video = p.querySelector('.stonepop__video');
    var src = el.dataset.video;
    if (src) {
      p.classList.add('has-video');
      if (video.getAttribute('src') !== src) video.setAttribute('src', src);
      video.play().catch(function () {});
    } else {
      p.classList.remove('has-video');
      video.pause();
    }
    var r = el.getBoundingClientRect();
    var w = 240, h = 210;
    var x = Math.max(12, Math.min(r.left + r.width / 2 - w / 2, innerWidth - w - 12));
    var y = r.top - h - 12;
    if (y < 12) y = r.bottom + 12;
    p.style.left = x + 'px';
    p.style.top = y + 'px';
    p.classList.add('on');
  }
  function hidePop() {
    if (!pop) return;
    pop.classList.remove('on');
    var v = pop.querySelector('.stonepop__video');
    if (v) v.pause();
  }

  /* ═══════════ ÉCRAN DE SUCCÈS ═══════════ */
  function initSuccess() {
    var overlay = doc.getElementById('SuccessOverlay');
    if (!overlay || !overlay.classList.contains('on') || overlay.dataset.done) return;
    overlay.dataset.done = '1';
    var card = overlay.querySelector('.gsuccess__card');
    if (card && !REDUCED) {
      var colors = ['#5563cf', '#8494f0', '#2563eb', '#2f3aa0', '#c7d2fe'];
      for (var i = 0; i < 26; i++) {
        var c = doc.createElement('span');
        c.className = 'confetti';
        c.style.left = (4 + Math.random() * 92) + '%';
        c.style.background = colors[i % colors.length];
        c.style.setProperty('--cd', (Math.random() * 0.5) + 's');
        c.style.transform = 'rotate(' + (Math.random() * 180) + 'deg)';
        card.appendChild(c);
      }
    }
    setTimeout(function () { var b = overlay.querySelector('.gsuccess__close'); if (b) b.focus(); }, 500);
  }

  /* ═══════════ DÉLÉGATION GLOBALE : CLICS ═══════════ */
  doc.addEventListener('click', function (e) {
    var t;

    /* sélecteur de sujet : devis / renseignements */
    if ((t = e.target.closest('[data-mode-btn]'))) {
      var mcard = t.closest('.form-card');
      if (mcard) {
        var mode = t.dataset.modeBtn;
        if (mcard.dataset.mode !== mode) {
          mcard.dataset.mode = mode;
          mcard.querySelectorAll('[data-mode-btn]').forEach(function (b) {
            var on = b === t;
            b.classList.toggle('on', on);
            b.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          var d = mcard.dataset;
          var get = function (k) { return d[mode + k] || ''; };
          var title = mcard.querySelector('[data-mode-title]'); if (title) title.textContent = get('Title');
          var sub = mcard.querySelector('[data-mode-sub]'); if (sub) sub.textContent = get('Sub');
          var cta = mcard.querySelector('[data-cta-text]'); if (cta) cta.textContent = get('Cta');
          var subj = mcard.querySelector('[data-subject-field]'); if (subj) subj.value = get('Subject');
          var body = doc.getElementById('ContactForm-body');
          if (body && !body.value) { body.placeholder = get('Ph'); body.dataset.defaultHint = get('Ph'); }
          updateMeter();
        }
      }
      return;
    }

    /* cartes projet */
    if ((t = e.target.closest('.proj'))) {
      var projField = doc.querySelector('[data-proj-field]');
      var body = doc.getElementById('ContactForm-body');
      var wasOn = t.classList.contains('on');
      doc.querySelectorAll('.proj').forEach(function (o) { o.classList.remove('on'); o.setAttribute('aria-checked', 'false'); });
      if (!wasOn) {
        t.classList.add('on'); t.setAttribute('aria-checked', 'true');
        if (projField) projField.value = t.dataset.proj || '';
        if (body && t.dataset.hint) body.placeholder = t.dataset.hint;
      } else {
        if (projField) projField.value = '';
        if (body && body.dataset.defaultHint) body.placeholder = body.dataset.defaultHint;
      }
      hidePop(); updateMeter();
      return;
    }

    /* nuancier matières (formulaire) */
    if ((t = e.target.closest('.swatches .swatch'))) {
      var stoneField = doc.querySelector('[data-stone-field]');
      var on = t.classList.contains('on');
      doc.querySelectorAll('.swatches .swatch').forEach(function (o) { o.classList.remove('on'); o.setAttribute('aria-checked', 'false'); });
      if (!on) {
        t.classList.add('on'); t.setAttribute('aria-checked', 'true');
        if (stoneField) stoneField.value = t.dataset.stone || '';
      } else if (stoneField) {
        stoneField.value = '';
      }
      hidePop(); updateMeter();
      return;
    }

    /* onglets du guide */
    if ((t = e.target.closest('.gtab'))) {
      doc.querySelectorAll('.gtab').forEach(function (o) { o.classList.remove('on'); o.setAttribute('aria-selected', 'false'); });
      t.classList.add('on'); t.setAttribute('aria-selected', 'true');
      showGuideTab(t); hidePop();
      return;
    }

    /* accordéons FAQ */
    if ((t = e.target.closest('.qa__q'))) {
      var qa = t.closest('.qa');
      var isOpen = qa.classList.contains('open');
      doc.querySelectorAll('.qa.open').forEach(function (o) {
        o.classList.remove('open');
        var b = o.querySelector('.qa__q'); if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) { qa.classList.add('open'); t.setAttribute('aria-expanded', 'true'); }
      return;
    }

    /* palette */
    if (e.target.closest('[data-ask]')) { openPalette(); return; }
    if ((t = e.target.closest('.palette__item'))) { t.parentElement.classList.toggle('open'); return; }
    if (e.target.closest('[data-palette-close]')) { closePalette(); return; }
    var pal = doc.getElementById('AskPalette');
    if (pal && e.target === pal) { closePalette(); return; }

    /* écran de succès */
    if (e.target.closest('.gsuccess__close')) {
      var ov = doc.getElementById('SuccessOverlay'); if (ov) ov.classList.remove('on');
      return;
    }
    var ov2 = doc.getElementById('SuccessOverlay');
    if (ov2 && e.target === ov2) ov2.classList.remove('on');
  });

  /* ═══════════ DÉLÉGATION GLOBALE : SAISIE ═══════════ */
  doc.addEventListener('input', function (e) {
    var t = e.target;
    if (t.id === 'ContactForm-phone') {
      var caretAtEnd = t.selectionStart === t.value.length;
      var formatted = formatFr(t.value);
      if (formatted !== t.value) {
        t.value = formatted;
        if (caretAtEnd) try { t.setSelectionRange(formatted.length, formatted.length); } catch (err) {}
      }
      t.setCustomValidity('');
    }
    if (t.closest('#ContactForm')) updateMeter();
    var palInput = t.closest('[data-palette-input]');
    if (palInput) renderPalette(palInput.value);
  });

  doc.addEventListener('invalid', function (e) {
    if (e.target.id === 'ContactForm-phone') {
      e.target.setCustomValidity('Veuillez saisir un numéro de téléphone français valide, ex. : 06 12 34 56 78');
    }
  }, true);

  /* ═══════════ DÉLÉGATION : SURVOL (aperçu matière) ═══════════ */
  if (matchMedia('(hover: hover)').matches) {
    doc.addEventListener('mouseover', function (e) {
      var t = e.target.closest('.swatch, .gtab');
      if (!t || !t.closest('[data-stonepop]')) return;
      clearTimeout(popTimer);
      popTimer = setTimeout(function () { showPop(t); }, 180);
    });
    doc.addEventListener('mouseout', function (e) {
      if (e.target.closest('.swatch, .gtab')) { clearTimeout(popTimer); hidePop(); }
    });
    addEventListener('scroll', hidePop, { passive: true });
  }

  /* ═══════════ EFFETS SOURIS (halo, 3D, magnétique, parallaxe) ═══════════ */
  if (!REDUCED) {
    doc.addEventListener('mousemove', function (e) {
      var card = e.target.closest('.form-card');
      if (card) {
        var r = card.getBoundingClientRect();
        card.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        card.style.setProperty('--my', (e.clientY - r.top) + 'px');
      }
      var step = e.target.closest('.gstep');
      if (step) {
        var rs = step.getBoundingClientRect();
        var px = (e.clientX - rs.left) / rs.width - 0.5;
        var py = (e.clientY - rs.top) / rs.height - 0.5;
        step.style.transform = 'perspective(90rem) rotateY(' + (px * 5) + 'deg) rotateX(' + (py * -5) + 'deg) translateY(-.5rem)';
        step.dataset.tilt = '1';
      }
      var btn = e.target.closest('.gcta');
      if (btn) {
        var rb = btn.getBoundingClientRect();
        btn.style.setProperty('translate', (((e.clientX - rb.left) / rb.width - 0.5) * 10) + 'px ' + (((e.clientY - rb.top) / rb.height - 0.5) * 6) + 'px');
        btn.dataset.mag = '1';
      }
      var hero = e.target.closest('.ghero');
      var layers = doc.querySelector('[data-parallax]');
      if (hero && layers) {
        var rh = hero.getBoundingClientRect();
        layers.style.transform = 'translate(' + (((e.clientX - rh.left) / rh.width - 0.5) * -18) + 'px,' + (((e.clientY - rh.top) / rh.height - 0.5) * -12) + 'px)';
      }
    });
    doc.addEventListener('mouseout', function (e) {
      var step = e.target.closest('.gstep');
      if (step && step.dataset.tilt && !step.contains(e.relatedTarget)) { step.style.transform = ''; delete step.dataset.tilt; }
      var btn = e.target.closest('.gcta');
      if (btn && btn.dataset.mag && !btn.contains(e.relatedTarget)) { btn.style.removeProperty('translate'); delete btn.dataset.mag; }
      var hero = e.target.closest('.ghero');
      if (hero && !hero.contains(e.relatedTarget)) {
        var layers = doc.querySelector('[data-parallax]');
        if (layers) layers.style.transform = '';
      }
    });
  }

  /* ═══════════ CLAVIER : CTRL+K / ÉCHAP ═══════════ */
  addEventListener('keydown', function (e) {
    if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k' && doc.getElementById('AskPalette')) {
      e.preventDefault(); openPalette();
    }
    if (e.key === 'Escape') closePalette();
  });

  /* ═══════════ COMPARATEUR & LECTURE & DOTNAV ═══════════ */
  doc.addEventListener('input', function (e) {
    var range = e.target.closest('.compare__range');
    if (range) range.closest('[data-compare]').style.setProperty('--pos', range.value + '%');
  });

  function updateReadbar() {
    var bar = doc.querySelector('.readbar');
    if (!bar) return;
    var max = doc.documentElement.scrollHeight - innerHeight;
    bar.style.setProperty('--read', (max > 0 ? (scrollY / max) * 100 : 0) + '%');
  }
  addEventListener('scroll', updateReadbar, { passive: true });

  var dotIO = null;
  function initDotnav() {
    var dots = doc.querySelectorAll('.dotnav a');
    if (!dots.length || !('IntersectionObserver' in window)) return;
    if (dotIO) { dotIO.disconnect(); dotIO = null; }
    var map = {};
    dots.forEach(function (d) {
      var target = doc.getElementById(d.dataset.dot);
      if (!target) { d.style.display = 'none'; return; }
      d.style.display = '';
      map[d.dataset.dot] = d;
    });
    dotIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && map[e.target.id]) {
          dots.forEach(function (d) { d.classList.remove('on'); });
          map[e.target.id].classList.add('on');
        }
      });
    }, { rootMargin: '-40% 0px -50% 0px' });
    Object.keys(map).forEach(function (id) { dotIO.observe(doc.getElementById(id)); });
  }

  /* ═══════════ INITIALISATION (rejouable à volonté) ═══════════ */
  function initAll() {
    var body = doc.getElementById('ContactForm-body');
    if (body && !body.dataset.defaultHint) body.dataset.defaultHint = body.placeholder;
    bindReveals();
    splitTitle();
    sizeBanner();
    updateStatus();
    initGuide();
    updateMeter();
    updateReadbar();
    initDotnav();
    initSuccess();
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  addEventListener('load', function () { sizeBanner(); });
  addEventListener('resize', function () { sizeBanner(); });

  /* Éditeur Shopify : une section vient d'être rechargée → on rejoue tout */
  doc.addEventListener('shopify:section:load', function () { setTimeout(initAll, 80); });
  doc.addEventListener('shopify:section:reorder', function () { setTimeout(initAll, 80); });
})();
